import type { AltAreaBehavior } from "components/scrapEyeLabelling/hooks/useLabellingKeyboard";
import { DEFAULT_VIDEO_QUALITY, isVideoQuality } from "hooks/hlsVideoQuality";
import type { VideoVariant } from "store/api/generatedApi";

export enum LocalStorageKeys {
  language = "language",
  hotkeysEnabled = "hotkeysEnabled",
  manualReviewAreaHotkeyBehaviour = "manualReviewAreaHotkeyBehaviour",
  lowMemoryVideoMode = "lowMemoryVideoMode",
  videoQuality = "videoQuality",
}

export const dumpVideoQuality = (quality: VideoVariant) => {
  localStorage.setItem(LocalStorageKeys.videoQuality, quality);
};

export const loadVideoQuality = (): VideoVariant => {
  const stored = localStorage.getItem(LocalStorageKeys.videoQuality);
  return isVideoQuality(stored) ? stored : DEFAULT_VIDEO_QUALITY;
};

export const dumpLanguage = (language: string) => {
  localStorage.setItem(LocalStorageKeys.language, language);
};

export const loadLanguage = (): string | null => {
  return localStorage.getItem(LocalStorageKeys.language);
};

export const dumpHotkeysEnabled = (hotkeysEnabled: boolean) => {
  localStorage.setItem(
    LocalStorageKeys.hotkeysEnabled,
    hotkeysEnabled.toString()
  );
};

export const loadHotkeysEnabled = (): boolean => {
  const stored = localStorage.getItem(LocalStorageKeys.hotkeysEnabled);
  return stored !== null ? stored === "true" : false;
};

export const dumpManualReviewAreaHotkeyBehaviour = (
  behaviour: AltAreaBehavior
) => {
  localStorage.setItem(
    LocalStorageKeys.manualReviewAreaHotkeyBehaviour,
    behaviour
  );
};

export const loadManualReviewAreaHotkeyBehaviour = (): AltAreaBehavior => {
  const stored = localStorage.getItem(
    LocalStorageKeys.manualReviewAreaHotkeyBehaviour
  );
  return stored === "record" ? "record" : "relabel";
};

export const dumpLowMemoryVideoMode = (enabled: boolean) => {
  localStorage.setItem(LocalStorageKeys.lowMemoryVideoMode, enabled.toString());
};

export const loadLowMemoryVideoMode = (): boolean =>
  localStorage.getItem(LocalStorageKeys.lowMemoryVideoMode) === "true";
